import { useEffect, useState } from "preact/hooks";
import { api } from "../api";
import { MacroRings } from "../components/MacroRings";
import { Wellness } from "../components/Wellness";
import type { DaySummary } from "@hh/shared";

const todayStr = () =>
  new Date().toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });

export function Today({ reloadKey, onGoLog, onLogout, onChanged }: { reloadKey: number; onGoLog: () => void; onLogout: () => void; onChanged: () => void }) {
  const [day, setDay] = useState<DaySummary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    setLoading(true);
    api.day().then((d) => { if (on) { setDay(d); setLoading(false); } }).catch(() => on && setLoading(false));
    return () => { on = false; };
  }, [reloadKey]);

  const t = day?.targets;
  const tot = day?.totals ?? { kcal: 0, protein_g: 0, carbs_g: 0, fat_g: 0 };
  const logged = (day && Object.values(day.byMeal).some((m) => m.length > 0)) || false;
  const proteinLeft = t ? Math.max(0, t.protein_g - tot.protein_g) : 0;

  return (
    <div class="app-shell fade-in">
      <div class="screen-head">
        <div><div class="eyebrow">{todayStr()}</div><h1>Today</h1></div>
        <button class="btn ghost" style={{ width: "auto", padding: "8px 12px", fontSize: 13 }} onClick={onLogout}>
          Sign out
        </button>
      </div>

      <div class="card">
        {t ? (
          <MacroRings
            kcal={tot.kcal}
            kcalTarget={t.kcal}
            protein={{ label: "Protein", value: tot.protein_g, target: t.protein_g, color: "var(--protein)" }}
            carbs={{ label: "Carbs", value: tot.carbs_g, target: t.carbs_g, color: "var(--carbs)" }}
            fat={{ label: "Fat", value: tot.fat_g, target: t.fat_g, color: "var(--fat)" }}
          />
        ) : (
          <div class="empty"><p>{loading ? "Loading…" : "No targets yet."}</p></div>
        )}
      </div>

      {t && (
        <div class="card">
          <h2>Remaining</h2>
          <div class="macro-bar">
            <div class="seg2"><div class="v">{Math.max(0, t.kcal - tot.kcal)}</div><div class="l">kcal</div></div>
            <div class="seg2"><div class="v">{proteinLeft}<span class="unit">g</span></div><div class="l">protein</div></div>
            <div class="seg2"><div class="v">{Math.max(0, t.carbs_g - tot.carbs_g)}<span class="unit">g</span></div><div class="l">carbs</div></div>
            <div class="seg2"><div class="v">{Math.max(0, t.fat_g - tot.fat_g)}<span class="unit">g</span></div><div class="l">fat</div></div>
          </div>
        </div>
      )}

      {!logged && !loading && (
        <div class="card">
          <div class="empty">
            <div class="ico">🍳</div>
            <p style={{ color: "var(--text-dim)", fontWeight: 600 }}>Nothing logged yet</p>
            <p>The rings fill as you go.</p>
            <button class="btn" style={{ marginTop: 12 }} onClick={onGoLog}>Log something</button>
          </div>
        </div>
      )}

      <Wellness reloadKey={reloadKey} onChanged={onChanged} />

      <div class="card">
        <div class="empty" style={{ padding: "24px 20px" }}>
          <div class="ico">🐕</div>
          <p style={{ color: "var(--text-dim)", fontWeight: 600 }}>Daily dog walk</p>
          <p>2.1 mi, ~45 min — the keystone. Even a short one counts.</p>
        </div>
      </div>
    </div>
  );
}
